export { CardAgeEntity } from './card-age';
